import React from 'react'

const CalendarBlackSvg = ({ width }) => {
  return (
    <svg
      id='calendar-33-svgrepo-com'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 14.39 14.799'
    >
      <path
        id='Path_3010'
        data-name='Path 3010'
        d='M121.057,2.992a.837.837,0,0,0,.837-.837V.837a.837.837,0,0,0-1.675,0V2.155A.837.837,0,0,0,121.057,2.992Z'
        transform='translate(-116.95)'
        fill='#2a2a2a'
      />
      <path
        id='Path_3011'
        data-name='Path 3011'
        d='M334.68,2.992a.837.837,0,0,0,.837-.837V.837a.837.837,0,0,0-1.675,0V2.155A.837.837,0,0,0,334.68,2.992Z'
        transform='translate(-324.398)'
        fill='#2a2a2a'
      />
      <path
        id='Path_3012'
        data-name='Path 3012'
        d='M19.447,41.288h-.518v.961a1.573,1.573,0,1,1-3.146,0v-.961H12.754v.961a1.573,1.573,0,1,1-3.146,0v-.961H9.089A2.016,2.016,0,0,0,7.073,43.3v9.573a2.016,2.016,0,0,0,2.016,2.016H19.447a2.016,2.016,0,0,0,2.016-2.016V43.3A2.016,2.016,0,0,0,19.447,41.288Zm.429,11.235a.935.935,0,0,1-.934.934H9.594a.935.935,0,0,1-.934-.934V45.034H19.876v7.489Z'
        transform='translate(-7.073 -40.095)'
        fill='#2a2a2a'
      />
      <rect
        id='Rectangle_578'
        data-name='Rectangle 578'
        width='2.047'
        height='2.046'
        transform='translate(6.171 9.68)'
        fill='#2a2a2a'
      />
      <rect
        id='Rectangle_579'
        data-name='Rectangle 579'
        width='2.047'
        height='2.046'
        transform='translate(2.999 9.68)'
        fill='#2a2a2a'
      />
      <rect
        id='Rectangle_580'
        data-name='Rectangle 580'
        width='2.047'
        height='2.047'
        transform='translate(9.344 6.508)'
        fill='#2a2a2a'
      />
      <rect
        id='Rectangle_581'
        data-name='Rectangle 581'
        width='2.047'
        height='2.046'
        transform='translate(9.344 9.68)'
        fill='#2a2a2a'
      />
      <rect
        id='Rectangle_582'
        data-name='Rectangle 582'
        width='2.047'
        height='2.047'
        transform='translate(6.171 6.508)'
        fill='#2a2a2a'
      />
      <rect
        id='Rectangle_583'
        data-name='Rectangle 583'
        width='2.047'
        height='2.047'
        transform='translate(2.999 6.508)'
        fill='#2a2a2a'
      />
    </svg>
  )
}

export default CalendarBlackSvg
